import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router }    from '@angular/router';
import { map }                       from 'rxjs/operators';
import { AuthenticationService }     from '../../../core/auth/authentication.service';
import { SsoService }                from '../../../core/auth/sso.service';
import { InternalRoutes }            from '../../../shared/data/internal-routes';

@Component({template: ''})
export class LogoutPageComponent implements OnInit {
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private authService = inject(AuthenticationService);
  private ssoService = inject(SsoService);

  ngOnInit() {
    this.authService.isAuthenticated()
      .pipe(
        map(sessionChangedData => sessionChangedData?.sso)
      )
      .subscribe(isSsoUser => {
        if (isSsoUser && this.activatedRoute.snapshot.fragment === 'ssoLogout') {
          this.ssoService.getSsoLogoutUrl().subscribe(logoutUrl => window.location.replace(logoutUrl))
        } else {
          this.authService.logout(!!this.activatedRoute.snapshot.queryParamMap.has('sessionExpired')).subscribe({
            next: () => this.router.navigate([isSsoUser ? 'sso-session-ended' : 'login'], {queryParamsHandling: 'preserve'}),
            error: (err) => {
              console.error('Logout failed', err);
              this.router.navigate([InternalRoutes.ERROR]).then();
            }
          })
        }
      });
  }
}